<script lang="ts">
    import { afterUpdate, onMount } from "svelte";
    import type { MapillaryManager } from "../MapillaryManager";

    export let manager: MapillaryManager;
    
    let controlRoot: HTMLElement;
    let viewerManager = manager.getViewerManager();
    let visible = viewerManager.getVisibleStore();

    onMount(() => {
        viewerManager.initialize(controlRoot);
    });

    afterUpdate(() => {
        viewerManager.resize();
    });

    const close = () => {
        viewerManager.close();
    }
</script>

<div class="mapillary-container {$visible ? '' : 'mapillary-container-none'}" bind:this={controlRoot}>
    <button
        type="button"
        class="btn-close btn-lg btn-close-lg"
        aria-label="Close"
        on:click={() => close()} />
</div>

<style>
    .mapillary-container {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 400px;
        height: 400px;
        z-index: 10000;
    }

    .mapillary-container-none {
        width: 0px;
        height: 0px;
    }

    .btn-close {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 100000;
    }
</style>
